import {useState, useEffect} from 'react';
import useTranslate from "../../../../utils/useTranslate"
import {
    BoardingAids
} from "../../../../data/products/BoardingAid";
import {ProductsProps} from "../Products";
import {InfoCircle as BSIconInfoCircle} from "react-bootstrap-icons";
import Button from 'react-bootstrap/Button';
import ProductsPlus from "../ProductsPlus";

import './ProductBoardingAid.scss';

export const ProductBoardingAid = ({selectProductVariant, ...props}: ProductsProps) => {
    const[haveInfoForProduct, setHaveInfoForProduct] = useState<boolean>(false);
    const {t} = useTranslate();

    useEffect(() => {
        let h = (props.infoForProduct !== undefined);
        if (haveInfoForProduct !== h) {
            setHaveInfoForProduct(h);
        }
    }, [props, haveInfoForProduct]);

    return (
            <div className="ams-product-item-boarding_aids">
                {
                    BoardingAids.map((iBoardingAid, iindex) => {
                        if (props.checkProduct !== undefined && !props.checkProduct(iBoardingAid)) {
                            return (null);
                        }
                        let title = t(iBoardingAid.title);
                        let info = t(iBoardingAid.info);
                        return (
                            <div key={"ams-product-item-boarding_aid-key-" + iindex}>
                                <div className="ams-product-item-boarding_aid-title">
                                    <span>{title}</span>
                                    {
                                        haveInfoForProduct && false &&
                                        <BSIconInfoCircle onClick={() => {
                                            if (props.infoForProduct !== undefined) {
                                                props.infoForProduct(iBoardingAid);
                                            }
                                        }} />
                                    }
                                </div>
                                {
                                    !haveInfoForProduct &&
                                    <div className="ams-product-item-boarding_aid-info">
                                        <div dangerouslySetInnerHTML={{__html: info}}></div>
                                    </div>
                                }
                                <div className="ams-product-item-boarding_aid-messures">{iBoardingAid.width} x {iBoardingAid.height} {t('mm')}</div>
                                <div className="ams-product-item-boarding_aid-subs">
                                    {
                                        iBoardingAid.variants.map((isBoardingAid, isindex) => {
                                            if (props.checkProductVariant !== undefined && !props.checkProductVariant(iBoardingAid, isBoardingAid)) {
                                                return (null);
                                            }
                                            let stitle = t(isBoardingAid.title);
                                            let shortInfo: string | null = isBoardingAid.shortInfo ? t(isBoardingAid.shortInfo) : null;
                                            return (
                                                <div key={"ams-product-item-boarding_aid-key-" + iindex + "-" + isindex}
                                                        className="ams-product-item-boarding_aid-sub">
                                                    <div onClick={() => {selectProductVariant(iBoardingAid, isBoardingAid);}}
                                                            className="ams-product-item-boarding_aid-image">
                                                        <img src={isBoardingAid.imageMenu} alt={title + " - " + stitle} title={title + " - " + stitle} />
                                                        {
                                                            !!stitle &&
                                                            <div className="ams-product-item-boarding_aid-sub-title">{stitle}</div>
                                                        }
                                                        {
                                                            props.checkProduct === undefined && props.checkProductVariant === undefined &&
                                                            <ProductsPlus />
                                                        }
                                                    </div>
                                                    {
                                                        !!shortInfo &&
                                                        <div className="ams-product-item-boarding_aid-sub-short-info">
                                                            <div dangerouslySetInnerHTML={{__html: shortInfo}}></div>
                                                            <div>
                                                                {
                                                                    haveInfoForProduct && false &&
                                                                    <Button variant="primary" onClick={() => {
                                                                            if (props.infoForProduct !== undefined) {
                                                                                props.infoForProduct(iBoardingAid);
                                                                            }
                                                                        }}>
                                                                        {t('Details')}
                                                                    </Button>
                                                                }
                                                            </div>
                                                        </div>
                                                    }
                                                </div>
                                            );
                                        })
                                    }
                                </div>
                            </div>
                        );
                    })
                }
            </div>
            );
};

export default ProductBoardingAid;
